import { FunctionTypes } from '../Enums/FunctionTypes';
import { Functions } from './Functions';
import { Function } from './Function';
import { Post, DummyPlainObject } from './Chat/Post';
import { PostFactory } from './Chat/PostFactory';

export class JsonToFunctions {
  public constructor(private json: string) {
  }

  private toObject(): Object {
    return JSON.parse(this.json);
  }

  private newFunction(functionsPlainObject: any) {
    if (functionsPlainObject.hasOwnProperty('lastupdate')) {
      const lastupdate = functionsPlainObject['lastupdate'];
      const functions: Functions = new Functions(new Date(lastupdate));
      delete (functionsPlainObject['lastupdate']);

      return functions;
    }

    return new Functions();
  }

  public toFunctions():Functions {
    const functionsPlainObject: any = this.toObject();
    if (!functionsPlainObject) return new Functions();
      
    const functions = this.newFunction(functionsPlainObject);
    
    if (!Object.keys(functionsPlainObject) || Object.keys(functionsPlainObject).length == 0) return functions;
      
    Object.keys(functionsPlainObject).forEach((uid: string) => {
      const funcPartial: Partial<Function<Post>> = functionsPlainObject[uid];
      const isString = (data: any): data is string => {
        return data.length != undefined;
      }
      if (isString(funcPartial.type)) {
        const functionType: string = funcPartial.type;
        const func = FunctionTypes.getInstance(functionType, funcPartial);
        functions.add(func);

        const list: Object = functionsPlainObject[uid]['list'];
        if (!list) return;
        this.toPostList(list, func);
      }
    });

    return functions;
  }

  private toPostList(_list: DummyPlainObject, parent: Post | Function<Post>) {
    Object.keys(_list).forEach((uid: string) => {
      const postPlainObject: DummyPlainObject = _list[uid];
      const post: Post = this.toPost(uid, postPlainObject);
      parent.postList.add(post);

      const list: Object = postPlainObject['list'];
      if (!list) return;
      this.toPostList(list, post);
    });
  }
  private toPost(uid:string, postPlainObject: Object) {
    return PostFactory.getInstance(uid, postPlainObject);
  }
}